import React from "react";
import { Box, Typography } from "@mui/material";
import { getUserFacingApiMessage } from "../utils/getUserFacingApiMessage";

/**
 * Conteúdo de Alert para erros de API: mensagem + próximo passo (userAction).
 * @param {unknown} error
 * @param {string} [fallback]
 */
export function resolveApiErrorNotice(error, fallback) {
  const facing = getUserFacingApiMessage(error);
  const message =
    facing.message && facing.message !== "Não foi possível concluir a operação."
      ? facing.message
      : fallback || facing.message;
  return {
    message,
    action: facing.action || null,
    code: facing.code || null,
  };
}

/**
 * @param {{ message: string, action?: string | null }} props
 */
export default function ApiErrorAlertBody({ message, action }) {
  if (!action) return message || null;
  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={700} component="div" gutterBottom>
        {message}
      </Typography>
      <Typography variant="body2" component="div" sx={{ opacity: 0.95 }}>
        {action}
      </Typography>
    </Box>
  );
}
